import { ChatActionsComponent } from '../components/chat/chat-actions.component';

export let menuConfig  = {
    home: [
        {
            icon: 'settings',
            link: '/member/profile/my-profile'
        },
        {
            title: 'Teaser',
            link: '/member/home',
            type: 'image',
            source: 'img/teaser.png',
            selected: true
        },
        {
            icon: 'chat',
            link: '/member/chat',
            chatUnreadBubble: true
        }
    ],
    chat: [
        {
            icon: 'settings',
            link: '/member/profile/my-profile'
        },
        {
            icon: 'flash',
            link: '/member/home',
        },
        {
            icon: 'chat',
            link: '/member/chat',
            selected: true
        }
    ],
    profile: [
        {
            icon: 'settings',
            link: '/member/profile/my-profile',
            selected: true
        },
        {
            icon: 'flash',
            link: '/member/home'
        },
        {
            icon: 'chat',
            link: '/member/chat',
            chatUnreadBubble: true
        }
    ],
    back: [
        {
            selected: true,
            type: 'back'
        },
        {
            icon: 'flash',
            link: '/member/home'
        },
        {
            icon: 'chat',
            link: '/member/chat',
            chatUnreadBubble: true
        }
    ],
    album: [
        {
            icon: 'left',
            link: '/member/profile/album/upload',
            selected: true
        },
        {
            icon: 'flash',
            link: '/member/home'
        },
        {
            icon: 'chat',
            link: '/member/chat',
            chatUnreadBubble: true
        }
    ],
    chatProfile: [
        {
            icon: 'left',
            link: '/member/chat'
        },
        {
            icon: 'flash',
            link: '/member/home'
        },
        {
            icon: 'contacts',
            selected: true,
            actionComponent: ChatActionsComponent
        }
    ],
    publicLogin: [
        {
            icon: 'left',
            link: '/'
        },
        {
            link: '/member/home',
            title: 'public.title'
        }
    ],
    publicLegals: [
        {
            icon: 'left',
            type: 'back'
        }
    ],
    publicLostPassword: [
        {
            icon: 'left',
            type: 'back'
        },
        {
            title: 'public.lostpassword.title'
        }
    ],
    publicRegistration: [
        {
        },
        {
            title: 'registration.title',
            cssClass: 'uppercase'
        }
    ],
    publicCookies: [
        {
            icon: 'left',
            type: 'back'
        },
        {
            title: 'account.cookies'
        }
    ]
};



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/config/menu-config.ts